import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON027_Request,
  IAPI_CON027_Response,
  IAPI_CON028_Request,
  IAPI_CON028_Response,
} from "../../../type/apiType";

// 法人施設職員新規契約情報参照API
const httpAPI_CON027 = async (
  param: IAPI_CON027_Request
): Promise<IAPI_CON027_Response> => {
  let res = await http.post(ApiUrl.API_CON027, {
    ...param,
  });

  return res.data;
};

// 法人施設職員新規契約情報更新API
const httpAPI_CON028 = async (
  param: IAPI_CON028_Request
): Promise<IAPI_CON028_Response> => {
  let res = await http.post(ApiUrl.API_CON028, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON027, httpAPI_CON028 };
